import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { DISCOUNT_MILESTONE_OFFSETS } from './DiscountScaleProgressMiniMilestone.constants';

export const styles = StyleSheet.create({
  milestoneWrapper: {
    position: 'absolute',
    transform: [
      { translateX: -DISCOUNT_MILESTONE_OFFSETS.desktop.x },
      { translateY: DISCOUNT_MILESTONE_OFFSETS.desktop.y },
    ],
    justifyContent: 'center',
    alignItems: 'center',
  },

  milestoneWrapperMobile: {
    position: 'absolute',
    transform: [
      { translateX: -DISCOUNT_MILESTONE_OFFSETS.mobile.x },
      { translateY: DISCOUNT_MILESTONE_OFFSETS.mobile.y },
    ],
    justifyContent: 'center',
    alignItems: 'center',
  },

  milestone: {
    width: 12,
    height: 12,
    borderRadius: 13,
    justifyContent: 'center',
    alignItems: 'center',
  },

  textNotActive: {
    ...textLatoStyleDS.BodyBoldXs,
    marginBottom: 6,
  },

  textPercentage: {
    ...textLatoStyleDS.BodyBoldXs,
  },

  checkIcon: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
